import Data from "./Data";
import Props from "./Props";
import Computed from "./Computed";
import Methods from "./Methods";
import Validation from "../Validation"

export default {
    name: "ListPageMixin",
    mixins: [Data, Props, Computed, Methods, Validation],
  /*  directives: {
        sortableDataTable: {
            bind (el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },*/
    watch: {
        pagination: {
            handler() {
                this.loadData();
            },
            deep: true
        }
    },
    mounted() {
        this.loadData();
    },
    created() {
        if (this.actionButtons && this.actionButtons.length) {
            const actionButtons = this.actionButtons.map(button => {

                if (button.clickHandler) {
                    button.clickHandler = this[button.clickHandler];
                }
                return button;
            });

            this.defaultActionButtons = this.showDefaultActionButtons ? this.defaultActionButtons.concat(actionButtons) : [...actionButtons];
        }
    }
}